import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/departamento_organizacion/departamento_organizacion';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.departamento_organizacion,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
